import { useTranslations } from '@storebrand-digital/fms-translations-react';
import { useContext } from 'react';
import handshake from '../../../assets/handshake.svg';
import Accordion from '../../../shared/components/Accordion';
import { RawHtmlFromTrustedSource } from '../../../shared/components/RawHtmlFromTrustedSource';
import { FormDataContext } from '../../Form';
import {
  Card,
  Description,
  DescriptionText,
  Icon,
  MobileIcon,
  Title
} from './styled';

export const MekleTextInfoField = () => {
  const { getText } = useTranslations();

  const formData = useContext(FormDataContext);
  const isPrivateReporter = formData.reporterOfLegalAid === 'PRIVATE';

  const title = getText('mekle.title');
  const description = isPrivateReporter
    ? getText('mekle.description')
    : RawHtmlFromTrustedSource({
        html: getText(`mekle.descriptionForLawyer`)
      });

  const accordionTitle = getText('mekle.accordionTitle');
  const content = getText('mekle.context');

  return (
    <Card>
      <MobileIcon src={handshake} alt="" />
      <Title>{title}</Title>
      <Description>
        <DescriptionText>{description}</DescriptionText>
        <Icon src={handshake} alt="" />
      </Description>
      {isPrivateReporter && (
        <Accordion title={accordionTitle} content={content} />
      )}
    </Card>
  );
};
